import { Component } from '@angular/core';
import { BaseSectionComponent } from '../base-section.component';
import { AssetPipe } from '../../../../../../../../pipes/asset.pipe';

@Component({
    selector: 'app-section-student-information',
    templateUrl: './section-student-information.component.html',
    styleUrls: ['./section-student-information.component.scss'],
    imports: [
        AssetPipe
    ],
    standalone: true
})
export class SectionStudentInformationComponent extends BaseSectionComponent {

}